import React from "react";

import SingleFamilyImg from "../../assets/images/Home/SingleFamily.png";
import MultiFamilyImg from "../../assets/images/Home/Multifamily.png";
import TownHallImg from "../../assets/images/Home/TownHomes.png";

type Props = {
  pType?: string;
  size?: number;
};

const ProjectTypeIcon: React.FC<Props> = ({ pType, size = 40 }) => {
  let iconSrc: string | null = null;

  if (pType) {
    const type = pType.trim().toLowerCase();

    if (type === "single family") {
      iconSrc = SingleFamilyImg;
    } else if (type === "multifamily") {
      iconSrc = MultiFamilyImg;
    } else if (type === "townhome") {
      iconSrc = TownHallImg;
    }
  }

  if (!iconSrc) {
    return <div style={{ width: size, height: size }} />;
  }

  return (
    <img
      src={iconSrc}
      width={size}
      height={size}
      alt={pType}
      style={{ objectFit: "contain" }}
    />
  );
};

export default ProjectTypeIcon;
